import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import {
	Container,
	ILearningExperience,
	LearningExperienceType,
} from '../../../../symphony';

import { SlLEContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { LocalizedLink } from '../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './CourseItemV3.scss';

interface ICourseItemV3Props {
	course: ILearningExperience;
}

export function CourseItemV3({ course }: ICourseItemV3Props): JSX.Element {
	useStyles(s);
	const {
		alias, name, uiConfigurations, typeId, description,
	} = course;

	const isLearningPath = typeId === LearningExperienceType.LearningPath;

	const handleCourseItemClick = (): void => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		actions$.next({
			type: isLearningPath
				? ActionType.OnLearningPathClick
				: ActionType.OnCourseClick,
			requestType: RequestType.Parallel,
			data: {
				alias,
			},
		});
	};

	const getLinkToCourse = (): string => `/learn/${isLearningPath ? 'learning-paths' : 'courses'
	}/${alias}`;

	return (
		<LocalizedLink
			onClick={handleCourseItemClick}
			to={getLinkToCourse()}
			className="le-course-item-v3"
			sl-test-data={`cmpCourseItemV3${alias}`}
		>
			<div className="le-course-item-v3__icon">
				<img src={uiConfigurations.iconUrl} alt={alias} />
			</div>
			<div className="le-course-item-v3__info">
				<p className="le-course-item-v3__title">{name}</p>
				<p className="le-course-item-v3__description">{description}</p>
			</div>
		</LocalizedLink>
	);
}
